/**
 * Notification filtering utilities
 * Centralized logic for determining which notifications should be shown
 */

/**
 * Checks if an order is an offline order based on its orderType
 * @param orderType - The order type from notification data
 * @returns true if the order is offline, false otherwise
 */
export const isOfflineOrder = (deepLink?: string): boolean => {
  if (!deepLink) return false;
  
  return (
    deepLink
      .includes('incomingDukaanOffline')
  );
};

/**
 * Determines if a notification should be suppressed
 * @param notificationData - The notification data object
 * @returns true if the notification should be suppressed, false otherwise
 */
export const shouldSuppressNotification = (
  notificationData?: Record<string, any>
): boolean => {
  if (!notificationData) return false;
  
  // Suppress offline order notifications
  const isOrderNotification = notificationData.type === 'order';
  if (isOrderNotification && isOfflineOrder(notificationData.deepLink)) {
    return true;
  }
  
  return false;
};
